import { CONTACT_CHANNELS, CONTACT_FAQ, CONTACT_INTRO, DECLARATIONS } from '@/content/contact';
import { CONTACT_FIELDS, CONTACT_MAIL_HEADING, CONTACT_MAIL_SUBJECT_PREFIX } from '@/content/forms';
import { Accordion } from '@/components/Controls';
import { Card } from '@/components/Card';
import { Icon } from '@/components/Icon';
import { MailForm } from '@/components/MailForm';
import { PageHero, Section, SectionHeading } from '@/components/Section';
import { Seo } from '@/components/Seo';

export function ContactPage() {
  return (
    <>
      <Seo
        path="/contact"
        crumbs={[
          { name: '首页', path: '/' },
          { name: '联系我们', path: '/contact' },
        ]}
      />

      <PageHero
        eyebrow={CONTACT_INTRO.eyebrow}
        title={CONTACT_INTRO.title}
        lead={CONTACT_INTRO.lead}
      />

      <Section>
        <div className="grid gap-5 md:grid-cols-3">
          {CONTACT_CHANNELS.map((channel) => (
            <Card key={channel.id} className="flex flex-col gap-3">
              <div className="flex items-center gap-3">
                <Icon name={channel.icon} size={18} className="text-fg-muted" />
                <span className="label-mono text-brand">{channel.label}</span>
              </div>
              <a
                href={channel.href}
                {...(channel.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                className="metric-value inline-flex items-center gap-1.5 break-all text-sm font-medium text-fg transition-colors hover:text-accent"
              >
                {channel.value}
                {channel.external ? <Icon name="external" size={14} /> : null}
              </a>
              <p className="text-xs leading-relaxed text-fg-muted">{channel.note}</p>
            </Card>
          ))}
        </div>
      </Section>

      <Section tone="raised">
        <div className="grid grid-cols-[minmax(0,1fr)] gap-10 lg:grid-cols-[minmax(0,1fr)_22rem] lg:items-start">
          <div>
            <SectionHeading
              eyebrow="留言"
              title="撰写邮件，或直接复制正文"
              lead="表单在浏览器中拼装邮件内容，不经过任何服务器。若希望使用自有邮箱发送，可将正文复制后发送至 contact@havorix.cn。"
              className="mb-8"
            />
            <MailForm
              fields={CONTACT_FIELDS}
              heading={CONTACT_MAIL_HEADING}
              subjectPrefix={CONTACT_MAIL_SUBJECT_PREFIX}
            />
          </div>

          <div className="flex flex-col gap-5">
            {DECLARATIONS.map((block) => (
              <Card key={block.title} className="flex flex-col gap-3">
                <div className="flex items-center gap-3">
                  <Icon name={block.icon} size={18} className="text-fg-muted" />
                  <h2 className="text-sm font-semibold text-fg">{block.title}</h2>
                </div>
                <div className="space-y-3 text-xs leading-relaxed text-fg-muted">
                  {block.paragraphs.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                </div>
              </Card>
            ))}
          </div>
        </div>
      </Section>

      <Section>
        <SectionHeading eyebrow="常见问题" title="您可能关心的问题" />
        <Accordion items={CONTACT_FAQ} className="mt-8 max-w-3xl" />
      </Section>
    </>
  );
}
